import { IRegenerateLetterModalForm } from 'models/driver-debt';
import * as Yup from 'yup';

export const RegenerateLetterSchema = () => {
    return Yup.object().shape({
        debtorLetter: Yup.mixed().required('required'),
    }) as Yup.SchemaOf<IRegenerateLetterModalForm>;
};
